/**
 * 此檔案是用來管理 querystring 參數
 */

export const QUERY_KEYS = Object.freeze({
    CONTINUE_DOC: 'continue-doc', // 此參數是用來轉跳到入會申請書或是移入申請書用
    IN_BODY_INTERVIEW: 'in-body-interview', // 此參數是用來轉跳到量身面談頁用
    MEMBER_DETAIL: 'member-detail', // 此參數是用來轉跳到會員頁用
});